import { DatePipe } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { SharedModule } from 'primeng/api'
import { ButtonModule } from 'primeng/button'
import { CardModule } from 'primeng/card'
import { InputTextModule } from 'primeng/inputtext'
import { MultiSelectModule } from 'primeng/multiselect'
import { Popover } from 'primeng/popover'
import { RippleModule } from 'primeng/ripple'
import { SplitterModule } from 'primeng/splitter'
import { TableModule } from 'primeng/table'
import { ToolbarModule } from 'primeng/toolbar'
import { TooltipModule } from 'primeng/tooltip'
import { TreeModule } from 'primeng/tree'

import { UtilitiesService } from '@app/services/utilities.service'
import { ConfigureFiltersModule } from '@app/components/configure-filters/configure-filters.module'
import { GenericModule } from '@app/components/generic/generic.module'
import { GlobalSearchModule } from '@app/components/global-search/global-search.module'

import { SearchListComponent } from './list/search-list.component'
import { SearchRoutingModule } from './search-routing.module'
import { SearchTreeComponent } from './tree/search-tree.component'

@NgModule({
  imports: [
    FormsModule,
    SharedModule,
    SplitterModule,
    TooltipModule,
    MultiSelectModule,
    TreeModule,
    Popover,
    CardModule,
    InputTextModule,
    ToolbarModule,
    ButtonModule,
    TableModule,
    GenericModule,
    GlobalSearchModule,
    SearchRoutingModule,
    ConfigureFiltersModule,
    RippleModule,
    DatePipe,
    SearchTreeComponent,
    SearchListComponent,
  ],
  providers: [
    UtilitiesService,
  ],
})
export class SearchModule {}
